
import { Button, Form, Input, Modal, Popover } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formItemLayout } from '../../utils/antUtils';
import { cancelSource, deleteSource, editInput, saveSource } from '../configActions';

const FormItem = Form.Item;

class ConfigSourceModalComponent extends Component {

  state = {
    confirmDeleteVisible: false
  }

  cancelDialog() {
    this.props.dispatch(cancelSource());
  }

  submit() {

    this.props.form.validateFields((errors) => {
      if (errors) {
        return false;
      }

      this.props.dispatch(saveSource(this.props.source));
    });
  }

  delete() {
    this.setState({ confirmDeleteVisible: false });
    this.props.dispatch(deleteSource(this.props.source.id));
  }

  onChange(value, entity, attr) {
    this.props.dispatch(editInput({ value, entity, attr }));
  }

  render() {
    let confirmPopup = (<div>
      <Button onClick={() => this.delete()}>Ja</Button>
      <Button style={{ marginLeft: 10 }} onClick={() => this.setState({ confirmDeleteVisible: false })}>Nej</Button>
    </div>);

    const { getFieldDecorator } = this.props.form;

    let footer = this.props.source.new ? [] : [<div style={{ float: 'left' }}>
      <Popover visible={this.state.confirmDeleteVisible} placement="topLeft" title={'Är du säker?'} content={confirmPopup} trigger="click">
        <Button type="danger" onClick={() => this.setState({ confirmDeleteVisible: true })} >Radera</Button>
      </Popover>
    </div>];

    footer.push(<Button key="back" onClick={() => this.cancelDialog()}>Avbryt</Button>);
    footer.push(<Button key="submit" type="primary" onClick={() => this.submit()}>Spara</Button>);

    return (

      <Modal
        title='Källa'
        visible={this.props.source.show}
        onCancel={() => this.cancelDialog()}
        footer={footer}
        maskClosable={false}
      >
        <div>
          <Form onSubmit={this.handleSubmit}>
            <FormItem {...formItemLayout} label="Id" >
              {getFieldDecorator('sourceId', { rules: [{ required: true, message: 'Ange ett Id' }], })(<Input disabled={!this.props.source.new} onBlur={(e) => this.onChange(e.target.value, 'source', 'id')} autoFocus />)}
            </FormItem>
            <FormItem {...formItemLayout} label="Namn" >
              {getFieldDecorator('sourceFullName', { rules: [{ required: true, message: 'Ange ett namn' }], })(<Input onBlur={(e) => this.onChange(e.target.value, 'source', 'fullName')} />)}
            </FormItem>
          </Form>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.config.loading,
  databases: state.config.databases,
  source: state.config.source
});

export default connect(mapStateToProps)(Form.create({
  mapPropsToFields(props) {

    return {
      sourceId: Form.createFormField({ value: props.source.id }),
      sourceFullName: Form.createFormField({ value: props.source.fullName })
    }
  }
})(ConfigSourceModalComponent));


// WEBPACK FOOTER //
// ./src/config/dialogs/configSourceModalComponent.js